import { render } from "./whiteCard.vue?vue&type=template&id=27b75f09"
import script from "./whiteCard.vue?vue&type=script&lang=js"
export * from "./whiteCard.vue?vue&type=script&lang=js"

import "./whiteCard.vue?vue&type=style&index=0&id=27b75f09&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__